<template>
  <div>
    <div class="d-flex align-center w-full px-2">
      <div class="w-25-porcento text-truncate" :title="Helpers.primeiraLetraMaiuscula(PEDIDO_SELECIONADO.nome_fornecedor || 'Sem fornecedor')">
        <span class="font-weight-medium">Fornecedor</span>:
        {{ Helpers.primeiraLetraMaiuscula(PEDIDO_SELECIONADO.nome_fornecedor || 'Sem fornecedor') }}
      </div>

      <div class="w-50-porcento h-48px d-flex align-center">
        <v-tabs
          v-model="tab_selecionado"
          centered
          :color="pedidos.length > 0 ? 'primary' : 'orange'"
          background-color="#F5F5F5"
        >
          <v-tab v-for="(pedido, index) in pedidos" :key="pedido.idpedido" :href="`#${index}`">
            {{ pedido.descricao_grupo }}

            <template v-if="pedido.filial !== info_pedido_geral.filial">
              - {{ `Filial ${pedido.filial}` }}
              <div v-if="pedido.descricao_filial" class="text-truncate w-max-150 pl-1">{{ pedido.descricao_filial }}</div>
            </template>

            <div v-if="pedido.idfornecedor !== info_pedido_geral.idfornecedor && Number(pedido.idfornecedor) !== -1" class="text-truncate w-max-150 pl-1">
              - {{ pedido.nome_fornecedor }}
            </div>
          </v-tab>

          <v-tab v-if="pedidos.length === 0">
            NENHUM PEDIDO EM ABERTO
          </v-tab>
        </v-tabs>

        <MenuMudarPedidoSelecionado
          v-if="pedidos.length > 0"
          v-model="tab_selecionado"
          :pedidos="pedidos"
          @excluir-pedidos-carrinho-produtos-a-comprar="$emit('excluir-pedidos-carrinho-produtos-a-comprar')"
        />

        <div class="h-full w-50 d-flex align-center justify-center">
          <ConsolidaPedidos
            v-if="PEDIDO_SELECIONADO.idpedido && !PEDIDO_SELECIONADO.pedido_produtos_combinados"
            :pedido_selecionado="PEDIDO_SELECIONADO"
          />
        </div>
      </div>

      <div class="w-25-porcento text-right text-truncate pl-1">
        <span class="font-weight-medium">Comprador</span>: {{ PEDIDO_SELECIONADO.nome_comprador || 'Sem comprador' }}
      </div>
    </div>

    <v-divider />

    <GridCarrinhoCompraProdutosGerais
      v-model="PEDIDO_SELECIONADO"
      :pedidos="pedidos"
      class="mt-1 pl-1"
      @update:produtos-pedido="ev => $emit('update:produtos-pedido', ev)"
    />
  </div>
</template>

<script>
import {pedidos_mixin} from "@/components/compra/ProdutosGerais/Carrinho/PedidosMixin";
import GridCarrinhoCompraProdutosGerais from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/Grid";
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import ConsolidaPedidos from "@/components/compra/ProdutosGerais/Carrinho/ConsolidaPedidos";
import MenuMudarPedidoSelecionado from "@/components/compra/ProdutosGerais/Carrinho/MenuMudarPedidoSelecionado";

export default {
  components: {
    MenuMudarPedidoSelecionado,
    ConsolidaPedidos,
    GridCarrinhoCompraProdutosGerais
  },
  mixins: [pedidos_mixin],
  name: "Index",
  data: () => ({
    info_pedido_geral,
    tab_selecionado: 0
  }),
  mounted() {
    document.addEventListener('mousedown', this._onMousedownGlobal, true);
  },
  destroyed() {
    document.removeEventListener('mousedown', this._onMousedownGlobal, true);
  },
  watch: {
    'pedidos': function () {
      this.tab_selecionado = 0;
    },
    'pedidos.length': function () {
      this.tab_selecionado = 0;
    },
    tab_selecionado: {
      handler: function () {
        if (this.pedidos[this.tab_selecionado]) {
          this.PEDIDO_SELECIONADO = this.pedidos[this.tab_selecionado];
        }
      }
    }
  },
  methods: {
    _onMousedownGlobal(event) {
      const elemento_ativo = document.activeElement;
      if (!elemento_ativo || elemento_ativo.tagName !== 'INPUT') return;
      if (!this.$el.contains(elemento_ativo)) return;
      if (elemento_ativo === event.target) return;
      elemento_ativo.blur();
    }
  }
}
</script>

<style scoped>

</style>
